import { Navigate, useLocation } from "react-router-dom";
import { getJWT, isTokenValid } from "../../services/auth";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = getJWT();

  return !token || !isTokenValid() ? (
    <Navigate to="/" state={{ from: location }} replace />
  ) : (
    children
  );
};

export default PrivateRoute;
